import React from 'react';
import './FormField.css';

export function FormField({ label, error, hint, children, required }) {
  return (
    <div className="form-field">
      {label && <label className="form-label">{label}{required && <span className="required">*</span>}</label>}
      {children}
      {hint && <span className="form-hint">{hint}</span>}
      {error && <span className="form-error">{error}</span>}
    </div>
  );
}

export function Input({ ...props }) {
  return <input className="form-input" {...props} />;
}

export function Select({ children, ...props }) {
  return <select className="form-input" {...props}>{children}</select>;
}

export function Textarea({ ...props }) {
  return <textarea className="form-input form-textarea" {...props} />;
}

export function SubmitBtn({ loading, children }) {
  return (
    <button type="submit" className="btn btn-primary" disabled={loading}>
      {loading ? <span className="btn-spinner"></span> : children}
    </button>
  );
}
